export const CURRENCY_SYMBOLS = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: '$',
    BRL: 'R$',
    INR: '₹',
    CHF: '₣'
  }
  
  export const getCurrencySymbol = (currencyCode) => {
    return CURRENCY_SYMBOLS[currencyCode] || currencyCode
  }